export const DEFAULT_LOGO_URL =
  'https://image-service-cdn.seek.com.au/fa20a06d67bf2704610885a5df7cf118b9567f33/f3c5292cec0e05e4272d9bf9146f390d366481d0';

export const brandName = {
  seek: 'SEEK',
  jobstreet: 'JobStreet',
  jobsdb: 'JobsDB',
} as const;
